import { useGraphQLAuth } from "hooks/useGraphQLAuth";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export interface TicketIngestionDetail {
  ticketIngestionId: string;
  eventSlug: string;
  eventId: string;
  externalTicketId: string;
  externalOrderId?: string | null;
  source?: string | null;
  status: string;
  holderName: string;
  cpf?: string | null;
  email?: string | null;
  phone?: string | null;
  company?: string | null;
  position?: string | null;
  passName?: string | null;
  category?: string | null;
  purchasedAt?: string | null;
  sourceUpdatedAt?: string | null;
  amountPaidCents?: number | null;
  paymentMethod?: string | null;
  insertDate: string;
  updateDate: string;
  lastSeenDate?: string | null;
  lastBatchId?: string | null;
  processed: boolean;
  registrationId?: string | null;
  customerId?: string | null;
  processedDate?: string | null;
  errorMessage?: string | null;
}

const QUERY = `
  query BackofficeTicketIngestion($ticketIngestionId: ID!) {
    backofficeTicketIngestion(ticketIngestionId: $ticketIngestionId) {
      ticketIngestionId
      eventSlug
      eventId
      externalTicketId
      externalOrderId
      source
      status
      holderName
      cpf
      email
      phone
      company
      position
      passName
      category
      purchasedAt
      sourceUpdatedAt
      amountPaidCents
      paymentMethod
      insertDate
      updateDate
      lastSeenDate
      lastBatchId
      processed
      registrationId
      customerId
      processedDate
      errorMessage
    }
  }
`;

export const useTicketIngestionDetails = () => {
  const { id } = useParams<{ id: string }>();
  const { connectGraphQLApi } = useGraphQLAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [ticket, setTicket] = useState<TicketIngestionDetail | null>(null);

  useEffect(() => {
    setLoading(true);
    connectGraphQLApi({
      query: QUERY,
      variables: { ticketIngestionId: id },
      errorMessage: "Falha ao carregar o ingresso",
      useNewApi: true,
    })
      .then((response: any) => {
        setTicket(response.data.backofficeTicketIngestion ?? null);
        setError(false);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { loading, error, ticket };
};
